import { DropdownWithSearch } from "InnoUI/innoinput";
import { selectSortType } from "utils/optionData/utils";
import styled from "@emotion/styled";

const SelectSortTypeDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
  placeholder,
}) => {
  const Options = selectSortType.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = Options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  const DropdownWrapper = styled.div`
    width: 100%;

    @media (min-width: 769px) {
      width: 32%;
    }
  `;

  return (
    <DropdownWrapper>
      <DropdownWithSearch
        defaultValue={defaultValue}
        options={Options}
        onChange={handleDropdownChange}
        borderColor="#E36E00"
        disabled={disabled}
        width="100%"
        dropdowType={name}
        placeholder={placeholder}
        height="40px"
        disabledDropdown={disabledDropdown}
      />
    </DropdownWrapper>
  );
};

export default SelectSortTypeDropdown;
